// extracted by mini-css-extract-plugin
module.exports = {"formdiv":"Admin_formdiv__1j29D"};